export const SRP_PAGE_NAME = 'new_used_car_inventory_srp';
